import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phone',
})
export class PhonePipe implements PipeTransform {
    transform(value: any): string {
        if (!value) {
            return '';
        }

        let cleaned = value.replace(/[^+\d]/g, '');

        if (cleaned.startsWith('0')) {
            cleaned = '+359' + cleaned.substring(1);
        }
        else if (cleaned.startsWith('+359')) { }
        else if (cleaned.startsWith('+')) { }
        else {
            // For example: 881231231 -> +359881231231
            cleaned = '+359' + cleaned;
        }

        return cleaned;
    }
}
